export const environment = {
    production: false,
    apiUrl: 'https://yxadmin-qa-aws.transnetyx.com/api',

    auth0: {
        domain: 'login-qa.transnetyx.com',
        clientId: '3nTwhV48ZSDSFta6PXIDfQ90ACvcRmmA',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts-qa.transnetyx.com/v2/logout/order-manager`,
        logoutUrl: 'https://login-qa.transnetyx.com/v2/logout',
    },

    colonyUrl: 'https://colony-qa.transnetyx.com/',
    automatedGenotypingUrl: 'https://quickorder-qa.transnetyx.com/Default.aspx',
    geneticMonitoringUrl: 'https://quickorder-qa.transnetyx.com/GeneticMonitoring/home',
    microbiomeUrl: 'https://quickorder-qa.transnetyx.com/MVC/Microbiome/home',
    quickorderUrl: 'https://quickorder-qa.transnetyx.com/MVC/Account/Register',
    quickorderStrainUrl: 'https://quickorder-qa.transnetyx.com/Strain.aspx',

    omDashboardUrl: 'https://ordermanager-qa.transnetyx.com/',
    omAccountsUrl: 'https://ordermanager-qa.transnetyx.com/Accounts/Default.aspx',
    omAssaysUrl: 'https://ordermanager-qa.transnetyx.com/AssayDesign/Default.aspx',
    omOrdersUrl: 'https://ordermanager-qa.transnetyx.com/Orders/Default.aspx',
    omPricingUrl: 'https://ordermanager-qa.transnetyx.com/Pricing/Default.aspx',
    omProbesUrl: 'https://ordermanager-qa.transnetyx.com/PredefinedProbes/Default.aspx',
    omPmUrl: 'https://ordermanager-qa.transnetyx.com/ProjectManagement/Default.aspx',
    omSalesUrl: 'https://ordermanager-qa.transnetyx.com/Sales/Dashboard.aspx',
    omShippingUrl: 'https://ordermanager-qa.transnetyx.com/Shipping/SupplyRequests.aspx',
    omStrainsUrl: 'https://ordermanager-qa.transnetyx.com/Strains/Default.aspx',
    omTagCenterUrl: 'https://ordermanager-qa.transnetyx.com/TAG/Default.aspx',
    omAccountOverviewUrl: 'https://ordermanager-qa.transnetyx.com/Accounts/User.aspx',
    omBannerSettingsUrl: 'https://ordermanager-qa.transnetyx.com/Admin/Banners/Default.aspx',
    omAccountsOrganizationsUrl: 'https://ordermanager-qa.transnetyx.com/Accounts/Organizations.aspx',
    omAccountsOnlineUsersUrl: 'https://ordermanager-qa.transnetyx.com/Accounts/UsersOnline.aspx',
    omAssaysSearchUrl: 'https://ordermanager-qa.transnetyx.com/AssayDesign/Search.aspx',
    omAssaysSequencingUrl: 'https://ordermanager-qa.transnetyx.com/AssayDesign/Sequencing.aspx',
    omAssaysProbesMfgUrl: 'https://ordermanager-qa.transnetyx.com/AssayDesign/ProbeManufacturing.aspx',
    omAssaysIncompleteSIFsUrl:
        'https://ordermanager-qa.transnetyx.com/AssayDesign/IncompleteStrainInformationForms.aspx',
    omAssaysConstructsUrl: 'https://ordermanager-qa.transnetyx.com/AssayDesign/Constructs.aspx',
    omOrdersCreateUrl: 'https://ordermanager-qa.transnetyx.com/Orders/OrderCreate.aspx',
    omOrdersPendingOrdersUrl: 'https://ordermanager-qa.transnetyx.com/Orders/OrdersPending.aspx',
    omOrdersIncompleteOrdersUrl: 'https://ordermanager-qa.transnetyx.com/Orders/OrdersIncomplete.aspx',
    omOrdersWellplateStorageUrl: 'https://ordermanager-qa.transnetyx.com/Orders/WellplateStorage.aspx',
    omPricingPromoCreditsUrl: 'https://ordermanager-qa.transnetyx.com/Pricing/Discounting.aspx',
    omPricingPaymentMethodsUrl: 'https://ordermanager-qa.transnetyx.com/Pricing/PaymentMethods.aspx',
    omProbesAddPredefinedProbesUrl: 'https://ordermanager-qa.transnetyx.com/PredefinedProbes/PredefinedProbeAdd.aspx',
    omProbesABIFileImportUrl: 'https://ordermanager-qa.transnetyx.com/PredefinedProbes/AbiOrderFileImport.aspx',
    omProbesManufacturingUrl: 'https://ordermanager-qa.transnetyx.com/PredefinedProbes/Manufacturing.aspx',
    omProbesSequencingUrl: 'https://ordermanager-qa.transnetyx.com/PredefinedProbes/Sequencing.aspx',
    omProbesIncompatibleProbesUrl: 'https://ordermanager-qa.transnetyx.com/PredefinedProbes/IncompatibleProbes.aspx',
    omPmTasksUrl: 'https://ordermanager-qa.transnetyx.com/ProjectManagement/Tasks.aspx',
    omPmNotesUrl: 'https://ordermanager-qa.transnetyx.com/ProjectManagement/Notes.aspx',
    omPmOrdersLimsUrl: 'https://ordermanager-qa.transnetyx.com/ProjectManagement/OrdersLims.aspx',
    omPmPendingOrdersUrl: 'https://ordermanager-qa.transnetyx.com/ProjectManagement/OrdersPending.aspx',
    omPmOfflineWellplatesUrl: 'https://ordermanager-qa.transnetyx.com/ProjectManagement/WellplatesOffline.aspx',
    omPmOfflineSequencingUrl: 'https://ordermanager-qa.transnetyx.com/ProjectManagement/SequencingTubesOffline.aspx',
    omPmStrainCopyUrl: 'https://ordermanager-qa.transnetyx.com/ProjectManagement/StrainCopy.aspx',
    omPmUnreceivedOrdersUrl: 'https://ordermanager-qa.transnetyx.com/ProjectManagement/OrdersNotReceived.aspx',
    omSalesAssayDesignUrl: 'https://ordermanager-qa.transnetyx.com/Sales/AssayDesign.aspx',
    omSalesNotesUrl: 'https://ordermanager-qa.transnetyx.com/Sales/Notes.aspx',
    omSalesProspectsUrl: 'https://ordermanager-qa.transnetyx.com/Sales/SalesProspects.aspx',
    omShippingCentralShippingUrl: 'https://ordermanager-qa.transnetyx.com/Shipping/CentralShipping.aspx',
    omShippingSequencingUrl: 'https://ordermanager-qa.transnetyx.com/Shipping/Sequencing.aspx',
    omShippingLabelSettingsUrl: 'https://ordermanager-qa.transnetyx.com/Shipping/LabelSettings.aspx',
    omOrderResultsUrl: 'https://ordermanager-qa.transnetyx.com/Orders/OrderResults.aspx',
    omStrainUrl: 'https://ordermanager-qa.transnetyx.com/Strains/Strain.aspx',
    omManagePickupsUrl: 'https://ordermanager-qa.transnetyx.com/Shipping/ManagePickups.aspx',
};
